import { useState } from 'react';
//
// TLS Dose Engine About Page
//
import gSession from '../script/session';

import TabWidget from './TabWidget';

const AboutPage = () => {
    const [title, setTitle] = useState("None")
    const [data, setData] = useState(null);

    const version = () => {
        return gSession.version();
    }

    // TODO: Why doesn't this work?
    const style = {
        "maxWidth": "200 px",
        "borderTop": "40 px",
        "marginTop": "40 px",
        "backgroudColor": "red"
    };

    function onSelect(name) {
        setTitle(name);
    }

    function onSetData() {
        let d = {
            items: [
                { title: "First", body: "This is the first item" },
                { title: "Second", body: "This is the second item" },
                { title: "Third", body: "This comes after Second" },
                { title: "Forth", body: "This is the last item" }
            ]
        };

        setData(d);
    }

    return (
        <div style={style}>
            <h1><span></span></h1>
            <div className="card text-white bg-primary mb-3">
                <div className="card-header">About</div>
                <div className="card-body">
                    <h4 className="card-title">TLS Dose Calculation Service</h4>
                    <p className="card-text">Network services and Monte Carlo dose calculation for BNCT treatment.</p>
                    <p className="card-text">{version()}</p>
                    <p className="card-text"><i>Copyright &copy; 2023 TAE Life Sciences</i></p>
                </div>
            </div>
            <div>
                <h1>{title}</h1>
                <TabWidget onSelect={onSelect} selected="One">
                    <h2 id="zero" title="Zero">Sub Zero content!</h2>
                    <h2 id="one" title="One">Sub We're number 1!</h2>
                    <h2 id="two" title="Two">Sub Just second fiddle here</h2>
                </TabWidget>
                <TabWidget onSelect={onSelect}>
                    {
                        data && data.items.map(item => (
                            <h2 title={item.title}>{item.body}</h2>
                        ))
                    }
                </TabWidget>
                <button type="button" className="btn btn-primary" onClick={onSetData}>Fill Data</button>
            </div>
        </div>
    );
}

export default AboutPage;